import React from "react";
import { QueryMeasuresDataShape } from "components/insights/utils/measureUtils";
import { formatNumber } from "utils/format/numberUtils";
import { useSelector } from "hooks/useSelector";
import { currentOrgSelector } from "store/selectors/core.selectors";
import { Headline, Highlight } from "components/insights/common/Headline";
import SystemMeasureDetail from "components/insights/measures/common/MeasureDetail";
import patientsImg from "./assets/patients.svg";
import styles from "components/insights/measures/common/MeasureDetail.module.scss";
import Meta from "components/common/Meta";

interface Props {
  data: QueryMeasuresDataShape;
  period: string;
  showDataTables: boolean;
}
const sectionName = "Patients in hospice care";

const SystemMeasurePatients = ({ data, period, showDataTables }: Props) => {
  const org = useSelector(currentOrgSelector);
  const dataMap = {
    referralSource: data["001"].data,
    diagnosis: data["002"].data,
    age: data["003"].data,
    ethnicity: data["004"].data,
    gender: data["005"].data,
    rurality: data["006"].data,
    livingSituation: data["007"].data,
  };
  return (
    <>
      <Meta title={"System Measures - Patients"} />
      <SystemMeasureDetail
        headline={
          <>
            <img
              src={patientsImg}
              className={styles.headlineImg}
              alt="patients"
            />
            <Headline
              num={formatNumber(data.total.patients)}
              // className={styles.headline}
            >
              people and their families and whānau <br /> were supported by{" "}
              <Highlight>{org.org_name}</Highlight> in{" "}
              <Highlight>{period}</Highlight>
            </Headline>
          </>
        }
        unit={sectionName}
        data={dataMap}
        showDataTables={showDataTables}
      />
    </>
  );
};

export default SystemMeasurePatients;
